// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__UjXy6","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3Xgp5"};